// Next's router tries to scroll a freshly-navigated page into view through
// React 19's Fragment-ref `scrollIntoView` — and on this storefront's
// hero-bearing routes (worse on `overlayRoute`s, whose hero carries a
// negative top margin) it is unreliable. First found on mobile, where the
// Sheet's closing scroll-lock teardown collides with it — but it reproduces
// on a bare desktop nav click too, no Sheet involved, and just the same on an
// in-page card link to a hero route (e.g. a destination/activity-type listing
// card). Flaky, not deterministic, so every internal link that lands on a
// hero route opts out of Next's scroll restoration with `scroll={false}` and
// calls this instead.
export function resetScrollOnNavigate(): void {
  window.scrollTo(0, 0);
}
